import { KnowledgeSourceAccordion } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/KnowledgeSourceAccordion/KnowledgeSourceAccordion';
import { AddItemIcon } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/AddItemIcon/AddItemIcon';
import { AddZendeskTicketsPopup } from 'src/pages/OnboardingPage/OnboardingSteps/OnboardingStep2/ZendeskTicketsAccordion/AddZendeskTicketsPopup/AddZendeskTicketsPopup';
import type { KnowledgeBase, KnowledgeBaseCollector } from 'src/services/knowledgeBaseService';

export const ZendeskTicketsAccordion = ({
  item = null,
  isButtonsDisabled = false,
  knowledgeBase,
}: {
  item?: KnowledgeBaseCollector | null;
  isButtonsDisabled?: boolean;
  knowledgeBase: Pick<KnowledgeBase, 'id'>;
}) => (
  <KnowledgeSourceAccordion
    item={item}
    isButtonsDisabled={isButtonsDisabled}
    knowledgeBase={knowledgeBase}
    icon={
      <div className={'pt-[4px]'}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="15"
          height="11"
          viewBox="0 0 15 11"
          fill="none"
        >
          <path
            d="M6.92308 2.90453V11.001H0L6.92308 2.90453ZM6.92308 0.000976562C6.92308 1.84362 5.36538 3.35123 3.46154 3.35123C1.55769 3.35123 0 1.84362 0 0.000976562H6.92308ZM8.07692 11.001C8.07692 9.15834 9.63461 7.65072 11.5385 7.65072C13.4423 7.65072 15 9.15834 15 11.001H8.07692ZM8.07692 8.09742V0.000976562H15L8.07692 8.09742Z"
            fill="#05050D"
          />
        </svg>
      </div>
    }
    title={'Zendesk tickets'}
    description={'Teach your AI from solved tickets'}
    collapsible={false}
    addHasPointer={false}
    addPopup={
      <AddZendeskTicketsPopup
        disabled={isButtonsDisabled}
        knowledgeBaseId={knowledgeBase.id}
        trigger={<AddItemIcon />}
      />
    }
  />
);
